<template>
  <div>
    <Toast />

    <div class="card">
      <h4 class="p-mb-5">
        <b>Detail Penerimaan Barang</b>
      </h4>
      <div class="p-grid">
        <div class="p-col p-mb-5">
          <label>Kode Barang</label>
          <div>{{ item.item_code }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label>Nama Barang</label>
          <div>{{ item.item_name }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label>Kategori</label>
          <div>{{ item.category_code }} - {{ item.category_name }}</div>
        </div>

        <div class="p-col p-mb-3 p-mr-5">
          <label>Supplier</label>
          <div>{{ item.supplier_code }} - {{ item.supplier_name }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label>Stok</label>
          <div>{{ item.stock | number }}</div>
        </div>

        <div class="p-col-12">
          <table class="table table-responsive text-center">
            <thead class="thead-light">
              <tr>
                <th class="text-center">No</th>
                <th class="text-center">Doc Date</th>
                <th class="text-center">Doc Number</th>
                <th class="text-center">Warehouse</th>
                <th class="text-center">Outlet Source</th>
                <th class="text-center">Price</th>
                <th class="text-center">Qty</th>
                <th class="text-center">Total Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in outlet_inbounds" :key="k">
                <td>{{ k + 1 }}</td>
                <td>{{ an_item.doc_date }}</td>
                <td>{{ an_item.doc_number }}</td>
                <td v-if="an_item.warehouse_code != ''">
                  {{ an_item.warehouse_name }}
                </td>
                <td v-else>-</td>
                <td v-if="an_item.outlet_code_source != ''">
                  {{ an_item.outlet_name_source }}
                </td>
                <td v-else>-</td>
                <td>{{ an_item.price | currency }}</td>
                <td>{{ an_item.qty | number }}</td>
                <td>{{ (an_item.qty * an_item.price) | currency }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <label>Total</label>
                </td>
                <td>{{ total_qty | number }}</td>
                <td>{{ total_price | currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loading: true,
      item: {},
      outlet_inbounds: null,
      total_qty: 0,
      total_price: 0
    }
  },
  mounted() {
    this.loading = false
    this.getDetailInbound()
  },
  computed: mapState(['user', 'isAuthenticated']),
  methods: {
    getDetailInbound() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbound/${this.$route.query.code}`
        )
        .then(response => {
          if (response.status === 200) {
            this.item = response.data.data.item
            this.outlet_inbounds = response.data.data.outlet_inbounds
            this.outlet_inbounds.forEach(e => {
              this.total_qty += parseInt(e.qty)
              this.total_price += parseInt(e.price) * parseInt(e.qty)
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
